<template>
    <div
        class="flex justify-between items-center w-full px-3 py-4 border-l-2 dark:bg-slate-800 bg-gray-200 border-l-white dark:border-l-gray-700 dark:text-gray-300">

        <div class="flex items-center">
            <img src="@/assets/user5.svg" v-if="!conversation?.profile || conversationIsLoading" alt=""
                class="w-10 h-10 p-2 mr-1 rounded-full  dark:bg-slate-950">
            <img :src="conversation?.profile" v-else alt=""
                class="w-10 h-10 p-2 mr-1 rounded-full  dark:bg-slate-950">
            <div class="" v-if="conversationIsLoading">
                <b> ... </b>
            </div>
            <div class="  py-2 flex items-center text-center justify-center text-red-950 dark:text-gray-500 "
                v-else-if="!conversationIsSuccess">

                <i class="las la-exclamation-triangle text-md   mr-1"></i>
                <div class=" font-bold  rounded-lg">
                    Impossible de charger cette conversation,Ressayez
                </div>
            </div>
            <div class="" v-else>
                <b>{{ conversation?.name ?? 'Citoyen' }}</b>
                <div class="text-xs font-light dark:text-gray-200 text-gray-800">{{conversation?.chat_id?.split('@')[0] ?? ' '}}</div>
            </div>
        </div>

        <div class="flex justify-end items-center gap-x-4 " v-if=" !conversationIsLoading">
            <button v-if="(conversation?.agent_id == user?.id  && conversation?.parent_conversation_id  &&   !conversation?.can_close)  " class="py-2 px-4 bg-gray-800/90 rounded-lg mx-3 text-xs text-white font-semibold hover:scale-95"
                @click="showModalIgnore = true">
                Ignorer la conversation
            </button>
            <button v-if="conversation?.agent_id == user?.id && conversation?.status != 'close' && conversation?.can_close   " class="py-2 px-4 bg-blue-900/90 rounded-lg mx-3 text-xs text-white font-semibold hover:scale-95"
                @click="showModal = true">
                Clôturer la conversation
            </button>
            <i class="text-2xl cursor-pointer dark:text-gray-300 text-gray-700 las la-times"
                @click="conversationRestData"></i>
        </div>
        

        <div v-if="showModal" class="fixed inset-0 flex z-50 items-center justify-center bg-black/80" @click.stop="()=>{showModal = false}">
            <div class="bg-white p-5 rounded-lg shadow-lg w-96 text-center" @click.stop="()=>{}">
                <h2 class="text-lg font-semibold">Confirmer la clôture</h2>
                <p class="text-gray-600 my-3">Voulez-vous vraiment clôturer cette conversation ?</p>
                <div class="flex justify-center space-x-4 mt-4">
                    <button @click="confirmClose" class="px-4 py-2 bg-red-900/90 text-white rounded hover:bg-red-700">
                        Oui, Clôturer
                    </button>
                    <button @click="()=>{showModal = false}"
                        class="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400">
                        Annuler
                    </button>
                </div>
            </div>
        </div>
        <div v-if="showModalIgnore" class="fixed inset-0 flex z-50 items-center justify-center bg-black/80" @click.stop="()=>{showModalIgnore = false}">
            <div class="bg-white p-5 rounded-lg shadow-lg w-96 text-center" @click.stop="()=>{}">
                <h2 class="text-lg font-semibold">Ingorer la conversation</h2>
                <p class="text-gray-600 my-3">Voulez-vous vraiment ignorer cette conversation ?</p>
                <div class="flex justify-center space-x-4 mt-4">
                    <button @click="confirmIgnoreConversation" class="px-4 py-2 bg-red-900/90 text-white rounded hover:bg-red-700">
                        Oui, Ignorer
                    </button>
                    <button @click="()=>{showModalIgnore = false}"
                        class="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400">
                        Annuler
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
    name: "MessageUserInfo",
    data() {
        return {
            showModal: false,
            showModalIgnore: false,
        };
    },
    computed: {
        ...mapFields("conversations/show", {
            conversationIsLoading: "isLoading",
            conversation: "item",
            conversationIsSuccess: "isSuccess",
            conversationMessage: "message",
            conversationShowMessage: "showMessage",
        }),
        ...mapFields("messages/list", {
            messageIsLoading: "isLoading",
            messageIsSuccess: "isSuccess",
        }),
        ...mapFields("auth/user", {
            user: "item",
        }),
        ...mapFields("messages/reply", {
            fileReply: "fileReply",
        }),


    },
    methods: {
        ...mapActions({
            resetMessages: "messages/list/resetData",
            resetReply: "messages/reply/resetData",
            resetConversation: "conversations/show/resetData",
            closedConversation: "conversations/update/closedConversation",
            mergeConversation: "conversations/update/mergeConversation",
        }),
        conversationRestData(){
            if(this.fileReply){
                this.fileReply = null
            }else{

                this.resetConversation();
                this.resetMessages();
                this.resetReply()
            }
        },
       
        confirmClose() {
            this.showModal = false;
            this.closedConversation();
            // Fermer la page de détails après clôture
            this.resetConversation();
            this.resetMessages();
            this.resetReply();
        },
        confirmIgnoreConversation() {
            this.showModalIgnore = false;
            this.mergeConversation();
            // Fermer la page de détails après ignore
            this.resetConversation();
            this.resetMessages();
            this.resetReply();
        }

    },
}
</script>